import { normalizeString } from '../functions';

const referralSchema = {
  context: (context) =>
    normalizeString({ data: context, actions: ['spacing'] }),
};

export default referralSchema;
